<template>
<header>
    {{userDetail.display_name}}
    <div class="h-left">
        <a @click="$router.go(-1); setFooter(false)"><img src="~@/assets/images/icon02.svg" /></a>
    </div>
</header>
<div id="wrap">
    <div class="prof-ph">
        <p class="prof-ph03">{{userDetail.display_name}}</p>
        <p class="prof-ph04">
            <span v-if="userDetail.is_private == 1">
                <i class="far fa-eye-slash grey"></i>
            </span>
            <span v-else class="green" style="margin-right: 7px; white-space: pre;">●</span>
            {{ getFieldProfile('living_area', userDetail.living_area) + " " }}{{ userDetail.age }}歳 {{ " " + getGender(userDetail.sex) }}
            <i class="fas fa-heart red" style="margin-left: 7px;"></i> {{ userDetail.total_like }}いいね！
            <span v-if="parseInt(userDetail.sex) === MALE">
                <i class="fas fa-coins yellow"></i> {{ getFieldProfile('income', userDetail.income) }} &nbsp;
            </span>
            <span v-if="parseInt(userDetail.sex) === FEMALE">
                <i class="fas fa-phone pink"></i> 通話{{ getCallStatus(userDetail.enabled_call) }}
                <i v-if="IS_WAITING_FOR_MEET === parseInt(userDetail.waiting_for_meet)" class="fas fa-calendar-check pink2" style="margin-left: 7px;"></i> 本日OK
            </span>
        </p>
        <div class="prof-bg"></div>
        <div v-for="(item, index) in getImage(userDetail.image)" :key="index">
            <img v-if="img_index === index" :src="getImageUrl(item.path)" />
        </div>
    </div>

    <div class="prof-title">ひとこと</div>
    <div style="padding: 16px 3%" class="txt-area">
        <p v-if="userDetail.mood_status_tmp" style="margin-top: -6px;">{{ userDetail.mood_status_tmp }}</p>

        <ul class="prof-ph02 clearfix parent_avatar_content">
            <li v-for="(item, index) in getImage(userDetail.image)" :key="index" class="parent_avatar">
                <img v-if="index == 0" :id="'img_' + index" :src="getImageUrl(item.path)" style="border: 2px solid salmon;box-sizing: border-box;" @click="showSubAvatar(index)" />
                <img v-else :id="'img_' + index" :src="getImageUrl(item.path)" @click="showSubAvatar(index)" />
                <!-- <div v-if="(item.is_approve === PC_APPROVE) || !checkApproveAvatar(item.path)">審査中</div> -->
            </li>
        </ul>
    </div>

    <div class="prof-title">自己紹介</div>
    <div class="txt-area">
        <p v-html="userDetail.user_status">
        </p>
    </div>

    <div class="prof-title">詳細プロフィール</div>

    <div class="porf-area">
        <table>
            <tr>
                <td>身長</td>
                <td class="right">{{ getFieldProfile('height', userDetail.height) }}</td>
            </tr>
            <tr>
                <td>体型</td>
                <td class="right">{{ getFieldProfile('style', userDetail.style) }}</td>
            </tr>
            <tr>
                <td>居住地</td>
                <td class="right">{{ getFieldProfile('living_area', userDetail.living_area) }}</td>
            </tr>
            <tr>
                <td>出身地</td>
                <td class="right">{{ getFieldProfile('birth_place', userDetail.birth_place) }}</td>
            </tr>
            <tr>
                <td>同居人</td>
                <td class="right">{{ getFieldProfile('roommate', userDetail.roommate) }}</td>
            </tr>
            <tr>
                <td>子供の有無</td>
                <td class="right">{{ getFieldProfile('child', userDetail.child) }}</td>
            </tr>
            <tr>
                <td>学歴</td>
                <td class="right">{{ getFieldProfile('education', userDetail.education) }}</td>
            </tr>
            <tr>
                <td>職業</td>
                <td class="right">{{ getFieldProfile('job', userDetail.job) }}</td>
            </tr>
            <tr>
                <td>年収</td>
                <td class="right">{{ getFieldProfile('income', userDetail.income) }}</td>
            </tr>
            <tr>
                <td>休日</td>
                <td class="right">{{ getFieldProfile('holidays', userDetail.holidays) }}</td>
            </tr>
            <tr>
                <td>お酒</td>
                <td class="right">{{ getFieldProfile('drinking', userDetail.drinking) }}</td>
            </tr>
            <tr>
                <td>タバコ</td>
                <td class="right">{{ getFieldProfile('smoking', userDetail.smoking) }}</td>
            </tr>
        </table>
    </div>

    <div class="prof-title">好きな事・趣味</div>
    <div class="porf-area">
        <table>
            <tr>
                <td>{{ userDetail.hobby ? userDetail.hobby : '未設定' }}</td>
            </tr>
        </table>
    </div>
    <div class="prof-title">よく行く場所</div>
    <div class="porf-area">
        <table>
            <tr>
                <td>{{ userDetail.favorite_place ? userDetail.favorite_place: '未設定'  }}</td>
            </tr>
        </table>
    </div>
    <div class="prof-title">初デートで行きたい場所</div>
    <div class="porf-area">
        <table>
            <tr>
                <td>{{ userDetail.first_place ? userDetail.first_place : '未設定' }}</td>
            </tr>
        </table>
    </div>
    <div class="prof-title">出会うまでの希望</div>
    <div class="porf-area">
        <table>
            <tr>
                <td>{{ getFieldProfile('meeting_condition', userDetail.meeting_condition) }}</td>
            </tr>
        </table>
    </div>
    <div class="prof-title">会った時の希望</div>
    <div class="porf-area">
        <table>
            <tr>
                <td>{{ getFieldProfile('purpose', userDetail.purpose) }}</td>
            </tr>
        </table>
    </div>
    <div class="porf-area">
        <table>
            <tr>
                <td></td>
            </tr>
        </table>
    </div>
    <div class="porf-area">
        <table>
            <tr>
                <td></td>
            </tr>
        </table>
    </div>
    <div class="porf-area">
        <table>
            <tr>
                <td></td>
            </tr>
        </table>
    </div>
    <div class="porf-area">
        <table>
            <tr>
                <td></td>
            </tr>
        </table>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import CONSTANTS from "@/constants"
import mixin from '@/mixin'
export default {
    mixins: [mixin],
    data: () => ({
        IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
        MALE: CONSTANTS.MALE,
        FEMALE: CONSTANTS.FEMALE,
        img_index: 0,
    }),
    computed: {
        ...mapGetters(["defaultToken", "metadata", "userDetail"]),
    },
    mounted() {
        this.setFooter(false)
        this.userProfile({
            token: this.defaultToken,
        });
    },
    methods: {
        ...mapActions({
            setFooter: "layout/setFooter",
            userProfile: "user/userProfile",
        }),
        getFieldProfile(field, id) {
            if (!this.metadata) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        getImage(images) {
            if (images) {
                let imgs = JSON.parse(images)
                if (imgs[0]) {
                    imgs = imgs.filter(item => {
                        return item.image_index == 0 || item.default === CONSTANTS.DEFAULT_AVATAR
                    })
                }
                return imgs
            }
        },
        checkApproveAvatar(image) {
            if (image.includes(CONSTANTS.URL_TEMP_AVATAR)) return false
            return true
        },
        showSubAvatar(index) {
            this.img_index = index;
            let avatar = document.getElementsByClassName('parent_avatar')
            for (var i = 0; i < avatar.length; i++) {
                avatar[i].getElementsByTagName('img')[0].style = '';
            }

            document.getElementById('img_' + index).style = "border: 2px solid salmon;box-sizing: border-box;";
        },
    },
};
</script>

<style scoped>
.parent_avatar {
    width: 100%;
    height: 92px;
    padding: 0 !important
}

/* .parent_avatar div {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #2c2c2c87;
    height: 100%;
    width: 100%;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
} */

.parent_avatar img {
    width: 92px;
    height: 92px;
    object-fit: cover;
    position: absolute;
    top: 0;
}

.parent_avatar_content {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 3px;
}
</style>
